import styles from "./StaffEmpty.module.scss";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import staffEmptyIcon from "../../../assets/images/icons/staff-empty.svg";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";
import plusIcon from "../../../assets/images/icons/plus-white.svg";
import StaffPopup from "../StaffPopup/StaffPopup";

interface IStaffEmptyProps {
  activeTab: "admin" | "support";
}

const StaffEmpty: React.FC<IStaffEmptyProps> = ({ activeTab }) => {
  const { t } = useTranslation();
  const [showCreatePopup, setShowCreatePopup] = useState<{
    show: boolean;
    activeTab: "admin" | "support";
  }>({ show: false, activeTab });

  const clickOnAddNew = () => {
    setShowCreatePopup({ show: true, activeTab });
  };

  return (
    <div className={styles.container}>
      <img src={staffEmptyIcon} alt={"empty"} />
      {activeTab === "admin" ? (
        <p className={styles.text}>{t("YouHaveNoAdminsYet")}</p>
      ) : (
        <p className={styles.text}>{t("YouHaveNoSupportsYet")}</p>
      )}
      <div className={styles.btnWrapper}>
        <CustomButton
          text={t("AddNew")}
          type={"button"}
          typeStyle={"fill"}
          icon={plusIcon}
          altIcon={"add"}
          functionOnClick={clickOnAddNew}
        />
      </div>
      {showCreatePopup.show && (
        <StaffPopup
          activeTab={showCreatePopup.activeTab}
          staffItem={null}
          setShowCreatePopup={setShowCreatePopup}
        />
      )}
    </div>
  );
};

export default StaffEmpty;
